import React from 'react';
import '../WatIsYogaPage/Styles.css';
import useTitle from '../../useTitle';
import ContactSection from '../ContactSection/Index';

const WatIsYoga = () => {
    useTitle("Wat is Yoga?");
  return (
    <>
      <div className='watIsYogaContainer'>
        <div className='watIsYogaItem'>
             <div className='watIsYogaImageContainer'>
                <img src='/images/IMG_2241.jpg' className='watIsYogaImage' alt='yoga mindful breaks' />
            </div>
            <div className='watIsYogaInfo'>
                <div className='watIsYogaTitleContainer'>
                    <h1 className='watIsYogaTitle'>Wat is yoga eigenlijk?</h1>
                </div>
                <div className='watIsYogaTitleDescription'>
                    <p>Yoga roept vaak heel wat beelden en vooroordelen op. Sommige denken dat je er super lenig voor moet zijn, of dat het allemaal zweverig is. Maar niets is minder waar! Misschien heb je gewoon niet de yogastijl ontdekt die echt bij jouw past. Want yoga is er voor iedereen en iedereen kan er gigantisch veel uit halen, zowel mentaal als fysiek.</p>
                    <br />
                    <p>Maar yoga is meer dan een reeks houdingen of wat rek- en strekoefeningen. Het gaat niet alleen om wat je op de mat doet, maar ook om wie je naast de mat bent. Het uiteindelijke doel? Dat je ook buiten de yogales met meer bewustzijn, balans en rust in het leven staat.</p>
                    <br />
                    <p>Door yoga leer je jezelf beter kennen: je ontdekt je sterke kanten, maar ook de patronen die je soms in de weg zitten. Zo krijg je stap voor stap meer verbinding met jezelf en anderen, meer harmonie in je dagelijks leven en een gevoel van vrijheid - lichamelijk, mentaal en spiritueel.</p>
                </div>
            </div>
        </div>
           
           
        </div>
        <ContactSection />
    </>
  )
}

export default WatIsYoga;
